import { render, staticRenderFns } from "./PasswordTips.vue?vue&type=template&id=393e50a4&scoped=true&"
import script from "./PasswordTips.vue?vue&type=script&lang=js&"
export * from "./PasswordTips.vue?vue&type=script&lang=js&"
import style0 from "./PasswordTips.vue?vue&type=style&index=0&id=393e50a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393e50a4",
  null
  
)

export default component.exports